import React, { useEffect, useRef } from "react";

function UserListItem({ avatar, name, handle, href }) {
  return (
    <li className="profile-user-list__item">
      <a href={href} className="profile-user-list__link">
        <img src={avatar} alt="" className="profile-user-list__avatar" />
        <span className="profile-user-list__body">
          <span className="profile-user-list__name">{name}</span>
          <span className="profile-user-list__handle">{handle}</span>
        </span>
      </a>
    </li>
  );
}

function UserList({ items, ariaLabel }) {
  return (
    <ul className="profile-user-list" aria-label={ariaLabel}>
      {items.map((u) => (
        <UserListItem
          key={u.id}
          avatar={u.avatar}
          name={u.name}
          handle={u.handle}
          href={u.href}
        />
      ))}
    </ul>
  );
}

function UserListModal({ id, title, users, ariaLabel, isOpen, onClose }) {
  // R8.3.7 — capture the original body overflow ONCE per open lifecycle.
  // Previous shape captured per [isOpen, onClose] effect run, which on a
  // rapid open→close→open cycle could capture `hidden` (set by the prior
  // run) as the "previous" value and then leave the body locked after the
  // final close. Ref persists across effect runs; cleared on restore so
  // the next open lifecycle starts fresh.
  const previousOverflowRef = useRef(null);
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    if (previousOverflowRef.current === null) {
      previousOverflowRef.current = document.body.style.overflow;
    }
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      if (previousOverflowRef.current !== null) {
        document.body.style.overflow = previousOverflowRef.current;
        previousOverflowRef.current = null;
      }
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const titleId = id + '-title';

  const handleOverlayMouseDown = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <>
      <div
        className="modal fade show project-modal"
        id={id}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        style={{ display: 'block' }}
        onMouseDown={handleOverlayMouseDown}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id={titleId}>{title}</h3>
              <div
                className="modal-btn-close"
                aria-label="Close"
                onClick={onClose}
              >
                <i className="fa-solid fa-xmark fa-2x"></i>
              </div>
            </div>
            <div className="modal-body modal-body--scrollable">
              <UserList items={users} ariaLabel={ariaLabel} />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default UserListModal;
